import React, { useState } from 'react';
import { Collapse, Table, Alert } from 'antd';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getTrustedFlagAudit } from '../../../hooks/users';
import { formatFullDate } from '../../../utils/dates';

const { Panel } = Collapse;

const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    margin-left: -16px;
  }
`;

const renderTrust = (value) => {
  if (value === null || value === undefined) return '—';
  return value === 'true' ? T('Trusted') : T('Not trusted');
};

const TrustedUserAuditHistory = ({ userPk }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleExpand = async (keys) => {
    const isOpen = Array.isArray(keys) ? keys.length > 0 : !!keys;
    if (!isOpen || loaded || loading) return;

    setLoading(true);
    setError(false);
    try {
      const data = await getTrustedFlagAudit(userPk);
      setRows(data);
      setLoaded(true);
    } catch (e) {
      setError(true);
      // eslint-disable-next-line no-console
      console.error('Failed to load trusted-flag audit history', e);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: T('Date/Time'),
      dataIndex: 'created_timestamp',
      key: 'created_timestamp',
      render: (v) => formatFullDate(v),
      width: 170,
    },
    {
      title: T('Previous value'),
      dataIndex: 'old_value',
      key: 'old_value',
      render: renderTrust,
      width: 120,
    },
    {
      title: T('New value'),
      dataIndex: 'new_value',
      key: 'new_value',
      render: renderTrust,
      width: 120,
    },
    {
      title: T('Changed by'),
      dataIndex: 'actor_email',
      key: 'actor_email',
      render: (v) => v || '—',
      ellipsis: true,
    },
  ];

  return (
    <StyledCollapse
      ghost
      onChange={handleExpand}
      style={{ marginTop: 8, width: '100%', maxWidth: 640 }}
    >
      <Panel header={T('Trusted user audit history')} key='audit'>
        {error ? (
          <Alert type='error' message={T('Could not load audit history')} showIcon />
        ) : (
          <Table
            columns={columns}
            dataSource={rows}
            loading={loading}
            rowKey={(_record, index) => String(index)}
            pagination={false}
            scroll={{ y: 240 }}
            size='small'
          />
        )}
      </Panel>
    </StyledCollapse>
  );
};

export default TrustedUserAuditHistory;
